import React from "react";
import EmployeeForm from "../../components/employeeForm/EmployeeForm";

function CreateEmployee() {
  return (
    <>
      <EmployeeForm />
    </>
  );
}

export default CreateEmployee;
